import { Box, ITheme, SvgIcon, Typography, useTheme, alpha } from '@mui/material'
import React from 'react'
import ProgressBar from '../../common/ProgressBar';
import { useTranslation } from 'react-i18next';
import { ReactComponent as compliantIcon } from '../../../assets/compliant.svg';

export interface IFundSelectionComplianceProgressProps {
  progress: number;
}

const FundSelectionComplianceProgress: React.FC<IFundSelectionComplianceProgressProps> = ({ progress }) => {
  const theme = useTheme() as ITheme;
  const { t } = useTranslation();
  return <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
    {progress === 1 ? <Box height={"22px"} width={"auto"} padding={"0 3px"} bgcolor={alpha(theme.palette.leo.color8, 0.3)} alignSelf={"self-start"} borderRadius={"4px"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
      <SvgIcon component={compliantIcon} inheritViewBox width={"16"} height={"16"} style={{color: theme.palette.secondary.main, height: "16px"}}/>
      <Typography color={theme.palette.secondary.main} fontSize={"11px"} lineHeight={"20px"} fontWeight={"600"}>{t('PortfolioPageELTIFCompliant')}</Typography>
    </Box>
      :
      <Box height={"22px"} width={"auto"} padding={"0 3px"} bgcolor={alpha(theme.palette.leo.semantic.red, 0.3)} alignSelf={"self-start"} borderRadius={"4px"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <SvgIcon component={compliantIcon} inheritViewBox width={"16"} height={"16"} style={{color: theme.palette.leo.semantic.red, height: "16px"}} />
        <Typography color={theme.palette.leo.semantic.red} fontSize={"11px"} lineHeight={"20px"} fontWeight={"600"}>{t('PortfolioPageELTIFNonCompliant')}</Typography>
      </Box>
    }
    {/* <Typography fontSize={"16px"} fontWeight={"500"} lineHeight={"12px"} color={theme.palette.leo.type[600]}>{Math.round(progress*100)}%</Typography>
    <ProgressBar proportion={progress} /> */}
  </Box>
}

export default FundSelectionComplianceProgress